<template>
  <div class="theme2-body">
    <KidHeader2
      v-if="currentProfile"
      :profileId="currentProfile._id"
      :serialNumber="currentProfile.deviceDetail.serialNumber"
      :isOnline="isDeviceOnline"
    />

    <main class="theme2-main-content" v-if="currentProfile">
      <!-- System Warnings -->
      <!--<div v-if="currentProfile" class="theme2-alert theme2-alert-danger">
          <div class="theme2-alert-icon">
              <svg class="theme2-icon" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
              </svg>
          </div>
          <div class="theme2-alert-content">
              <div class="theme2-alert-title">All applications have been disabled</div>
              <div class="theme2-alert-message">
                  because the device limit has been reached. Please increase the device limit to re-enable them now; otherwise, all applications will be automatically re-enabled when the day changes.
              </div>
          </div>
      </div>

      <div class="theme2-alert theme2-alert-warning">
          <div class="theme2-alert-icon">
              <svg class="theme2-icon" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
              </svg>
          </div>
          <div class="theme2-alert-content">
              <div class="theme2-alert-message">
                  You are currently using the default password. 
                  <a href="javascript:void(0)" @click="$router.push({ path: '/change-password'})" class="theme2-alert-link">Click here</a> 
                  to update your password for enhanced security.
              </div>
          </div>
      </div>-->

      <!-- NEW: Profile Selector Card -->
                  <!-- CORRECTED Profile Selector Card -->
            <div class="theme2-profile-selector">
                <div class="theme2-profile-header-new">
                    <!-- Avatar -->
                    <div class="theme2-profile-avatar-large">
                        <img v-if="existingProfilePic" :src="existingProfilePic" alt="Profile">
                        <span v-else>👧</span>
                    </div>
                    
                    <!-- Profile Info -->
                    <div class="theme2-profile-main-info">
                        <!-- Name and Edit Row -->
                        <div class="theme2-profile-name-row">
                            <button class="theme2-profile-switch-btn" @click="openKidsListModal">
                                {{ currentProfile.profile_name }}
                                <svg class="theme2-icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                                </svg>
                            </button>
                            <button class="theme2-profile-edit-icon" @click="openKidsprofilePageModal">
                                <svg class="theme2-icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"/>
                                </svg>
                            </button>
                        </div>
                        
                        <!-- Version Tag -->
                        <div class="theme2-profile-meta">
                            <span class="theme2-profile-version-tag">
                                <svg class="theme2-icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                                </svg>
                                v{{ currentProfile.deviceDetail.appVersion }}
                            </span>
                        </div>
                    </div>
                </div>
                
                <!-- Divider -->
                <div class="theme2-profile-divider"></div>
                
                <!-- Device Status Row -->
                <div class="theme2-profile-status-row">
                    <span class="theme2-profile-status-label">Device Status</span>
                    <div class="theme2-device-info-compact">
                        <!-- WiFi Badge -->
                        <div class="theme2-status-badge">
                            <svg v-if="currentProfile.deviceDetail.wifiConnected" class="theme2-icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"/>
                            </svg>
                            <svg v-else class="theme2-icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3"/>
                            </svg>
                            {{ currentProfile.deviceDetail.wifiConnected ? 'WiFi' : 'No WiFi' }}
                        </div>
                        
                        <!-- Battery Badge -->
                        <div class="theme2-status-badge">
                            <svg class="theme2-icon-xs" :class="getBatteryClass(currentProfile.deviceDetail.batteryPercentage)" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M3.75 18h15A2.25 2.25 0 0021 15.75v-7.5A2.25 2.25 0 0018.75 6h-15A2.25 2.25 0 001.5 8.25v7.5A2.25 2.25 0 003.75 18z"/>
                            </svg>
                            {{ currentProfile.deviceDetail.batteryPercentage }}%
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sleep Mode Card -->
            <div class="theme2-sleep-mode-card">
                <div class="theme2-sleep-mode-header">
                    <div class="theme2-sleep-mode-left">
                        <div class="theme2-sleep-icon-circle">
                            <svg width="24" height="24" fill="white" viewBox="0 0 24 24">
                                <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z"/>
                            </svg>
                        </div>
                        <div class="theme2-sleep-mode-info">
                            <div class="theme2-sleep-mode-title-new">
                                ☀️ Sleep Mode
                            </div>
                            <div class="theme2-sleep-mode-desc">
                                {{ sleepMode ? 'All apps blocked • Device locked' : 'Lock device and block all apps instantly' }}
                            </div>
                        </div>
                    </div>
                    
                    <div class="theme2-sleep-status-badge" :class="{'active': sleepMode}">
                        <span v-if="sleepMode">●</span>
                        {{ sleepMode ? 'Active' : 'Inactive' }}
                    </div>
                </div>
                
                <div class="theme2-sleep-mode-actions">
                    <button 
                        class="theme2-sleep-toggle-btn" 
                        :class="{'active': sleepMode}"
                        @click="toggleSleepMode"
                    >
                        <svg v-if="sleepMode" class="theme2-icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                        </svg>
                        {{ sleepMode ? 'Disable Sleep Mode' : 'Enable Sleep Mode' }}
                    </button>
                </div>
            </div>

      <!-- Location Card -->
      <!-- Enhanced Location Section -->
      <div v-if="currentProfile.deviceDetail.lastDeviceLocation" class="theme2-location-section">
          <div class="theme2-location-info">
              <div class="theme2-location-title-row">
                  <div class="theme2-location-main-title">
                      <svg class="theme2-icon-sm theme2-text-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                      </svg>
                      <span>Last Location</span>
                  </div>
                  <button class="theme2-refresh-btn" @click="refreshLocation">
                      <svg class="theme2-icon-xs" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                      </svg>
                      Refresh
                  </button>
              </div>
              
              <div class="theme2-location-details">
                  <div class="theme2-location-address">
                      {{ locationAddress || 'Fetching address...' }}
                  </div>
                  <div class="theme2-location-coords">
                      <span>{{ currentProfile.deviceDetail.lastDeviceLocation.latitude.toFixed(6) }}, {{ currentProfile.deviceDetail.lastDeviceLocation.longitude.toFixed(6) }}</span>
                      <svg class="theme2-icon-xs" fill="none" stroke="#10b981" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                      </svg>
                  </div>
                  <div class="theme2-location-updated">
                      Last Updated: {{ formatDateTime(currentProfile.deviceDetail.lastDeviceLocation.deviceDateTime) }}
                  </div>
              </div>
          </div>
          <div class="theme2-map-container">
              <iframe v-if="iframeMapUrl" :src="iframeMapUrl" width="100%" height="100%" frameborder="0"></iframe>
              <div v-else style="display: flex; align-items: center; justify-content: center; height: 100%; color: #6b7280;">
                  Loading map...
              </div>
          </div>
      </div>


      <!-- Activity Section -->
      <div class="theme2-activity-section">
        <div class="theme2-section-header">
          <h2 class="theme2-section-title">Activity</h2>
          <div class="theme2-filter-buttons">
            <button
              class="theme2-filter-btn"
              :class="{ 'theme2-active': filterType === 'Day' }"
              @click="changeFilterType('Day')"
            >
              Day
            </button>
            <button
              class="theme2-filter-btn"
              :class="{ 'theme2-active': filterType === 'Week' }"
              @click="changeFilterType('Week')"
            >
              Week
            </button>
          </div>
        </div>

        <!-- Date Navigator -->
        <div class="theme2-date-navigator">
          <button class="theme2-date-nav-btn" @click="previousDate">
            <svg
              class="theme2-icon-sm"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <span class="theme2-current-date">{{ formattedDate }}</span>
          <button class="theme2-date-nav-btn" @click="nextDate">
            <svg
              class="theme2-icon-sm"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>

        <!-- Screen Time Card -->
        <div class="theme2-card">
          <div class="theme2-card-body">
            <div class="theme2-screen-time-header">
              <h3 class="theme2-card-title">Screen Time</h3>
              <span class="theme2-screen-time-value">{{ totalUsedTime }}</span>
            </div>
            <div class="theme2-chart-placeholder">
              <CanvasJSChart
                v-if="options"
                :options="options"
                :styles="styleOptions"
              />
              <span v-else>No data available</span>
            </div>
          </div>
        </div>

        <!-- Most Used Apps -->
        <div class="theme2-card">
          <div class="theme2-card-header">
            <h3 class="theme2-card-title">Most Used Apps</h3>
          </div>
          <div
            v-if="mostUsedApplicationList.length > 0"
            class="theme2-app-list"
          >
            <div
              v-for="app in mostUsedApplicationList"
              :key="app.packageName"
              class="theme2-app-item"
              @click="navigateToApp(app)"
            >
              <div class="theme2-app-header">
                <div class="theme2-app-icon">
                  <img
                    v-if="app.playStoreDetail"
                    :src="app.playStoreDetail.icon"
                    alt="App Icon"
                  />
                  <span v-else>📱</span>
                </div>
                <div class="theme2-app-info">
                  <p class="theme2-app-name">
                    {{
                      app.playStoreDetail
                        ? app.playStoreDetail.title
                        : app.packageName
                    }}
                  </p>
                  <p v-if="!app.dailyLimit" class="theme2-app-time">
                    {{ app.timeInMinuteFormatted }}
                  </p>
                </div>
                <svg
                  class="theme2-icon-sm theme2-app-arrow"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </div>
              <div v-if="app.dailyLimit" class="theme2-progress-bar-container">
                <div
                  class="theme2-progress-bar"
                  :class="{
                    'theme2-danger': app.timeInMinute >= app.dailyLimit,
                  }"
                  :style="{ width: app.progressBarPercentage + '%' }"
                ></div>
              </div>
            </div>
          </div>
          <div v-else class="theme2-empty-state">No data to show</div>
        </div>

        <!-- Most Used Categories -->
        <div class="theme2-card">
          <div class="theme2-card-header">
            <h3 class="theme2-card-title">Most Used Categories</h3>
          </div>
          <div v-if="mostUsedCategory.length > 0" class="theme2-app-list">
            <div
              v-for="category in mostUsedCategory"
              :key="category._id"
              class="theme2-app-item"
              @click="navigateToCategory(category)"
            >
              <div class="theme2-app-header">
                <div class="theme2-app-icon">📂</div>
                <div class="theme2-app-info">
                  <p class="theme2-app-name">{{ category.category }}</p>
                  <p
                    v-if="!category.progressBarPercentage"
                    class="theme2-app-time"
                  >
                    {{ category.usedTimeFormat }}
                  </p>
                </div>
                <svg
                  class="theme2-icon-sm theme2-app-arrow"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </div>
              <div
                v-if="category.progressBarPercentage"
                class="theme2-progress-bar-container"
              >
                <div
                  class="theme2-progress-bar"
                  :class="{
                    'theme2-danger':
                      parseInt(category.usedTime) >=
                      parseInt(category.dailyLimitTime),
                  }"
                  :style="{ width: category.progressBarPercentage + '%' }"
                ></div>
              </div>
            </div>
          </div>
          <div v-else class="theme2-empty-state">No data to show</div>
        </div>

        <p class="theme2-last-update">Last Update: {{ lastUpdated }}</p>
      </div>
    </main>

    <KidFooter2
      v-if="currentProfile"
      :profileId="currentProfile._id"
      :serialNumber="currentProfile.deviceDetail.serialNumber"
      :requestCount="requestCount"
      @toggle-sidebar="toggleSidebar"
    />
  </div>
</template>

<script>
import KidsService from "../../services/KidsService";
import ProfileService from "../../services/ProfileService";
import KidHeader2 from "@/components/theme2/KidHeader2.vue";
import KidFooter2 from "@/components/theme2/KidFooter2.vue";

export default {
  name: "Dashboard2",
  components: {
    KidHeader2,
    KidFooter2,
  },
  data() {
    return {
      profileId: this.$route.query.profileId,
      currentProfile: null,
      mostUsedApplicationList: [],
      mostUsedCategory: [],
      currentDate: new Date(),
      formattedDate: new Date().toLocaleDateString("en-US", this.$dateOptions),
      lastUpdated: "No data found.",
      options: null,
      styleOptions: {
        width: "100%",
        height: "160px",
      },
      iframeMapUrl: "",
      filterType: "Day",
      weekType: "Current",
      totalUsedTime: "",
      sleepMode: false,
      existingProfilePic: null,
      showMap: false,
      requestCount: 0,
      useDefaultPassword: this.$route.query.useDefaultPassword,
      locationAddress: '',
      isDeviceOnline: true,
    };
  },
  methods: {
    refreshLocation() {
        // Implement refresh logic
        this.$toast.info('Refreshing location...');
    },
    getBatteryClass(percentage) {
      if (percentage > 80) return "theme2-text-green";
      if (percentage >= 20) return "theme2-text-yellow";
      return "theme2-text-red";
    },
    async getKidsList() {
      let data = {
        profileId: this.profileId,
        search_profile_type: "Android",
        pageSize: 50,
      };
      await KidsService.getKidsList(data)
        .then((response) => {
          const profileList = response.data.data;
          if (profileList.length > 0 && profileList[0].deviceDetail) {
            if (this.profileId) {
              const selectedProfile = profileList.find(
                (item) => item._id == this.profileId
              );
              this.currentProfile = selectedProfile;
            } else {
              this.currentProfile = profileList[0];
              this.profileId = profileList[0]._id;
            }
            this.existingProfilePic =
              this.currentProfile.deviceDetail.kidProfilePic;
            this.sleepMode = this.currentProfile.sleepMode;
            this.showMap =
              this.currentProfile.deviceDetail.enableLocationMapDisplay;

            this.getDeviceProfileMostUsedApplicationList();
            this.getMostUsedCategory();
            this.getCategoryStackedChart();

            if (this.currentProfile.deviceDetail.lastDeviceLocation) {
              let lat = parseFloat(
                this.currentProfile.deviceDetail.lastDeviceLocation.latitude
              );
              let long = parseFloat(
                this.currentProfile.deviceDetail.lastDeviceLocation.longitude
              );
              const zoomOutFactor = 0.001;
              const boundingBox = this.calculateBoundingBox(
                lat,
                long,
                zoomOutFactor
              );
              const bbox = `${boundingBox.west},${boundingBox.south},${boundingBox.east},${boundingBox.north}`;
              this.iframeMapUrl = `/map.html?lat=${lat}&long=${long}&zoom=12&bbox=${bbox}`;
            }

            if (this.currentProfile.deviceDetail.lastDeviceActivationDate) {
              this.lastUpdated =
                new Date(
                  this.currentProfile.deviceDetail.lastDeviceActivationDate
                ).toLocaleDateString("en-US", this.$dateOptions) +
                " " +
                new Date(
                  this.currentProfile.deviceDetail.lastDeviceActivationDate
                ).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                });
            }
          }
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    calculateBoundingBox(lat, long, factor) {
      return {
        west: long - factor,
        south: lat - factor,
        east: long + factor,
        north: lat + factor,
      };
    },
    async getDeviceProfileMostUsedApplicationList() {
      let data = {
        profileId: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType,
      };
      await KidsService.getDeviceProfileMostUsedApplicationList(data)
        .then((response) => {
          this.mostUsedApplicationList = response.data.data.slice(0, 3);
          this.totalUsedTime = response.data.totalUsedTime;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async getMostUsedCategory() {
      let data = {
        profileId: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType,
      };
      await KidsService.getMostUsedCategory(data)
        .then((response) => {
          this.mostUsedCategory = response.data.data.slice(0, 3);
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async getCategoryStackedChart() {
      let data = {
        profileId: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType,
      };
      await KidsService.getCategoryStackedChart(data)
        .then((response) => {
          this.options = response.data.data;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    changeFilterType(type) {
      this.filterType = type;
      if (this.filterType == "Day") {
        this.formattedDate = this.currentDate.toLocaleDateString(
          "en-US",
          this.$dateOptions
        );
      } else {
        this.formattedDate = "This Week";
        this.weekType = "Current";
      }
      this.getCategoryStackedChart();
      this.getDeviceProfileMostUsedApplicationList();
      this.getMostUsedCategory();
    },
    previousDate() {
      if (this.filterType == "Day") {
        let day = this.currentDate.getTime() - 1 * 24 * 60 * 60 * 1000;
        this.currentDate.setTime(day);
        this.formattedDate = this.currentDate.toLocaleDateString(
          "en-US",
          this.$dateOptions
        );
      } else {
        this.formattedDate = "Previous Week";
        this.weekType = "Previous";
      }
      this.getCategoryStackedChart();
      this.getDeviceProfileMostUsedApplicationList();
      this.getMostUsedCategory();
    },
    nextDate() {
      if (this.filterType == "Day") {
        let day = this.currentDate.getTime() + 1 * 24 * 60 * 60 * 1000;
        this.currentDate.setTime(day);
        this.formattedDate = this.currentDate.toLocaleDateString(
          "en-US",
          this.$dateOptions
        );
      } else {
        this.formattedDate = "This Week";
        this.weekType = "Current";
      }
      this.getCategoryStackedChart();
      this.getDeviceProfileMostUsedApplicationList();
      this.getMostUsedCategory();
    },
    async toggleSleepMode() {
      let data = {
        profileId: this.currentProfile._id,
        sleepMode: !this.sleepMode,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
      };
      await KidsService.toggleSleepMode(data)
        .then((response) => {
          this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    formatDateTime(datetime) {
      if (!datetime) return "";
      const date = new Date(datetime);
      const datePart = date.toLocaleDateString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
      const timePart = date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
      return `${datePart} ${timePart}`;
    },
    navigateToApp(app) {
      this.$router.push({
        path: "/application",
        query: {
          package_name: app.packageName,
          profile_id: this.currentProfile._id,
          serialNumber: this.currentProfile.deviceDetail.serialNumber,
        },
      });
    },
    navigateToCategory(category) {
      this.$router.push({
        path: "/category",
        query: {
          id: category._id,
          profileId: this.currentProfile._id,
          serialNumber: this.currentProfile.deviceDetail.serialNumber,
        },
      });
    },
    openKidsListModal() {
      // Implement kids list modal logic
    },
    openKidsprofilePageModal() {
      // Implement profile edit modal logic
    },
    toggleSidebar() {
      // This will be handled by header component
    },
  },
  beforeMount() {
    this.getKidsList();
  },
};
</script>
<style scoped>
@import "../../assets/theme2.css";
</style>